import styled from 'styled-components'

export const ContainerDoIcone = styled.span`
  display: flex;
  align-items: center;
`
